import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import { useSelector, useDispatch } from 'react-redux'
import { useRouter } from 'next/router'

import { AvatarIcon, TrackingIcon, LogoutIcon } from 'components/common'
import s from './Profile.module.css'

const Profile = ({ onLogoutClick }) => {
  const [isActive, setIsActive] = useState(false)

  const { data } = useSelector((state) => state.auth)

  const router = useRouter()

  useEffect(() => {
    const handleRouteChange = () => setIsActive(false)

    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  return (
    <div className={s.profile}>
      <button className={s.avatar} onClick={() => setIsActive(!isActive)}>
        <AvatarIcon width="35px" height="35px" style={{ cursor: 'pointer' }} />
      </button>

      {isActive && (
        <div className={s.tabsWrapper}>
          <div className={s.username}>{data.UserName}</div>

          <Link href="/orders">
            <a
              className={s.NaviationControl}
              onClick={() => setIsActive(false)}
            >
              <div className={s.tab}>
                <TrackingIcon className={s.trackingIcon} />
                <span>Orders</span>
              </div>
            </a>
          </Link>

          <Link href="/accountSettings">
            <a
              className={s.NaviationControl}
              onClick={() => setIsActive(false)}
            >
              <div className={s.tab}>
                <AvatarIcon className={s.logoutIcon} />
                <span>Account Settings</span>
              </div>
            </a>
          </Link>

          <div className={s.tab} onClick={onLogoutClick}>
            <LogoutIcon className={s.logoutIcon} />
            <span>Logout</span>
          </div>
        </div>
      )}
    </div>
  )
}

export default Profile
